import { Link, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export function ContentShell({ seo, children, ctaTitle = "See what an independent assessment surfaces." }) {
  const navigate = useNavigate();
  return (
    <div className="dark relative min-h-screen bg-[#0A1B2E] text-[#F5F5F5] font-body overflow-hidden">
      {seo}
      <div className="grain-overlay" />

      <nav className="fixed top-0 inset-x-0 z-50 bg-black/60 backdrop-blur-xl border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5 font-body font-bold text-2xl tracking-tight" data-testid="brand-logo">
            <img src="/retainproof-icon-dark.png" alt="RetainProof" className="h-8 w-auto" />
            <span>Retain<span className="text-[#0E7C7B]">Proof</span><sup className="text-[0.5em] font-normal align-super">™</sup></span>
          </Link>
          <div className="flex items-center gap-1 sm:gap-3">
            <Link to="/insights"><Button variant="ghost" className="hidden md:inline-flex text-zinc-300 hover:text-white hover:bg-white/5 rounded-none">Insights</Button></Link>
            <Link to="/pricing"><Button variant="ghost" className="hidden sm:inline-flex text-zinc-300 hover:text-white hover:bg-white/5 rounded-none">Pricing</Button></Link>
            <Link to="/about"><Button variant="ghost" className="hidden sm:inline-flex text-zinc-300 hover:text-white hover:bg-white/5 rounded-none">About</Button></Link>
            <Link to="/register"><Button className="bg-[#D5A44A] text-black hover:bg-[#B8923D] rounded-none font-medium" data-testid="content-get-started">Get started</Button></Link>
          </div>
        </div>
      </nav>

      <main className="relative z-10">{children}</main>

      <section className="relative z-10 border-t border-white/10 bg-[#0B1F33]">
        <div className="max-w-4xl mx-auto px-6 py-20 text-center">
          <h2 className="font-display text-3xl sm:text-4xl font-light tracking-tight">{ctaTitle}</h2>
          <p className="mt-4 text-zinc-400 max-w-2xl mx-auto">An independent, one-time review of your marketing spend, vendors and retained-case outcomes — no subscription.</p>
          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <Button onClick={() => navigate("/pricing")} className="bg-[#D5A44A] text-black hover:bg-[#B8923D] rounded-none h-12 px-8 text-base font-medium group" data-testid="content-pricing-cta">
              See assessment options <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Button>
            <Link to="/consultation"><Button variant="outline" className="rounded-none h-12 px-8 text-base border-white/25 text-white bg-transparent hover:bg-white/5" data-testid="content-consult-cta">Book a 15-minute call</Button></Link>
          </div>
        </div>
      </section>

      <footer className="relative z-10 border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-10 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-zinc-500">
          <span>© 2026 RetainProof™ · A product of CMD Marketing Enterprises LLC</span>
          <div className="flex gap-6">
            <Link to="/" className="hover:text-white">Home</Link>
            <Link to="/insights" className="hover:text-white">Insights</Link>
            <Link to="/pricing" className="hover:text-white">Pricing</Link>
            <Link to="/about" className="hover:text-white">About</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
